/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonVariant, Icon, Intent, Size, Tooltip } from "@blueprintjs/core"
import { MouseEvent, useEffect, useMemo, useState } from "react"
import { DIALOG_SIZE, ID } from "src/libs/interfaces/layouts"
import SubMenu from "src/libs/scalars/SubMenu"
import { Hint, ScalableDialog } from "src/libs/useful"
import CalloutNoExists from "src/libs/useful/CalloutNoExists"
import Shortcode from "src/libs/useful/shortcode"
import { __, sprintf } from "src/libs/utilities"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { schema } from "../../data/schema"
import { components } from "../../data/utils/components"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import { CompositeForm } from "./CompositeForm"
import PresetLib from "./PresetLib"
import PresetLibraryList from "./PresetLibraryList"

export enum CONTENT_TYPE {
    LIB="lib",
    VALUE="value"
}
export interface ILandingCompositeDefaultProps extends Omit<ICompositeWidgetProps, "onChange"> {
    onDelete?: ( id: ID ) => void 
    onSwitch?: ( i: number ) => void 
    onChange?: ( value: any, field: string, data: any ) => void
    i?: number
    length?: number
    sectionId?:ID
    children?: JSX.Element
    schemaType?: any
}
const LandingCompositeDefault = (props: ILandingCompositeDefaultProps): JSX.Element => {  
    const value         = useSyncState<any>(props.value || {})
    const contentType   = useSyncState<CONTENT_TYPE>(CONTENT_TYPE.VALUE)
    const _schema       = useMemo(() => schema(), [])

    useEffect(() => {
        value.set(props.value)
    }, [props.value])

    const getTitle = ( schemaType: any, visible_value: string = "" ): string | JSX.Element => { 
        if( !schemaType ) {
            return ""
        }
        
        if( props.title && typeof props.title === "string") { 
            return __( props.title )
        } 

        if( !!visible_value ) {
            const field: string = schemaType[ visible_value ] 
            return value.get() ? value.get()[ field ] : "title"
        }
        // Если  это контент секции
        if( schemaType.parentType === "LandingContent" ) { 
            const c =  components()[ props.type] || { }                     
            return <div className="d-flex align-items-center">
                <div className="d-flex">
                    { __( c.title )  || ""  }
                </div>
                {/* <div className="micro opacity_75 px-3 text-overflow" >
                    { value.get()?.id }
                </div> */}
            </div>
        }
        // Если - примитив
        if( schemaType.parentType === "Primitive" ) {                    
            return <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex">
                    <img src={`/assets/img/landing/${schemaType.type}.svg`} alt="" height={22} />
                    <div className="d-flex ml-2">
                        { __( value.get()?.type || "" ) }
                    </div>
                </div>
                
                <div className="smallest opacity_75 px-3 text-overflow" >
                    { value.get()?.id }
                </div>
            </div>
        }
        // Если это -- пин
        if( schemaType.type === "Float") {
            return <div className="d-flex align-items-center">
                <div className="d-flex">
                   Float + { __( "Float" ) }
                </div> 
                <div className="micro opacity_75 px-3 text-overflow" >
                    { value.get()?.id }
                </div>
            </div>
        } 
        return "" 
    }

    const [isOpen, setIsOpen]   = useState<boolean>( !!props.isDefaultOpen )
    const [isCollapsesOpen, setIsCollapsesOpen] = useState<boolean[]>([])
    const schemaData            = _schema[ props.type ] || {}
    let schemaType              = schemaData.apollo_fields 
    const parentTypeName        = schemaData.parentType
    const parentType            = _schema[ parentTypeName ]?.apollo_fields || {} 
    const parentType2           = _schema[ schemaData.parentType2 ]?.apollo_fields || {} 
    schemaType                  = { ...schemaType, parentType: parentTypeName, type: props.type, ...parentType2, ...parentType, } 
    const title                 = getTitle( schemaType, schemaData.visible_value ) || 
    <div className="d-flex align-items-center">
        <div className="smaller">{ JSON.stringify( value.get() ) }</div> 
        {(props.i || 0) + 1}. {__(schemaData.name)}
    </div> 
    
    if( !schemaType && !Object.keys(schemaType).length) { 
        console.log( props ) 
        return <CalloutNoExists message={sprintf( __(`Unknown data type —-- %s (%s)`), props.dataSection, props.type)} />
    }
    const onChange = (value: any, field: string, data: any) => { 
        if(props.onChange) {
            // console.log( value, field, props.field )
            props.onChange( value, field, data )
        }        
    }
    const onRmv = (evt:MouseEvent) => {
        evt.preventDefault()
        evt.stopPropagation() 
        if(props.onDelete) props.onDelete( value.get().id )
    }    
    const onCollapsesOpen = (i : number) => {
        let co  = [ ...isCollapsesOpen ]
        co[ i ] = !co[ i ]
        setIsCollapsesOpen( co )
    }

    const isFeed = () : boolean => { 
        return props.dataSection === "data"
    }
    const onLibOpen = ( ) => { 
        contentType.set(CONTENT_TYPE.LIB)
    } 

    const getVisibleTitle = (): string | JSX.Element  => {
        if(!schemaData.visible_value) { 
            return typeof title === "string"
                ?
                <Shortcode 
                    content={ title.toString() } 
                    className=" py-2 small opacity_75 flex-grow-100 overflow-hidden max-height-100" 
                    max_length={100 } 
                />
                :
                <div className=" py-2 flex-grow-100 overflow-hidden max-height-100" >
                    { title } 
                </div>
        } 
        const visible_value = value.get() ? value.get()[ schemaData.visible_value ] : ""
        if(typeof visible_value === "string")
            return <Shortcode 
                content={ visible_value.toString() } 
                className=" py-2 smaller opacity_75 flex-grow-100 overflow-hidden max-height-100" 
                max_length={100 } 
            /> 
        else
            return JSON.stringify( visible_value )
    }
    const onFieldChange = (value: any, field: string, dop: any) => {  
        onChange( value, field, dop ) 
    }
    return props.isAlwaysOpen 
        ? 
        <div className="px-3 ">
            <div className="pb-2 row mb-2 ">
                {
                    contentType.get() === CONTENT_TYPE.VALUE
                        ?
                        <CompositeForm 
                            schemaType={ schemaType } 
                            origin={ props.origin }
                            value={ value.get() }
                            onChange={ onFieldChange }
                            schemaData={ schemaData} 
                            onCollapsesOpen={ onCollapsesOpen }
                            isCollapsesOpen={ isCollapsesOpen }
                            sectionId={props.sectionId}
                        />
                        :
                        contentType.get() === CONTENT_TYPE.LIB
                            ?
                            <PresetLibraryList libName={ props.presetLib } />
                            :
                            <></>
                }
            </div>
        </div>
        :
        <CompositeContainer isNotCard={props.isNotCard} >
            { props.children }
            <SubMenu
                subMenus={props.subMenus}
                on={props.onSubmenu}
            /> 
            <Button 
                size={ Size.LARGE } 
                fill 
                variant={ ButtonVariant.MINIMAL }
                alignText="left"  
                onClick={ () => {
                    setIsOpen(!isOpen)  
                }} 
                onMouseOver={ (evt: MouseEvent) => {
                    contentType.set( CONTENT_TYPE.VALUE )
                    evt.stopPropagation()
                    evt.preventDefault()
                }}
                className="btn-stretch pl-2 py-0 pr-0"
            >
                <div className="d-flex w-100 align-items-center justify-content-between p-0">
                    <Hint 
                        position="top-left"
                        label={ typeof title === "string" ? __( title ) : title }
                    >
                        <div className="d-flex">
                            {
                                !!schemaData.icon &&
                                <img
                                    src={ schemaData.icon }
                                    height={ 20 }
                                    alt=""
                                    className="mx-3"
                                />
                            }
                        </div>
                    </Hint> 
                    { getVisibleTitle() } 
                    {
                        isFeed() && 
                            <div className="ml-auto pe-surface"> 
                                <Tooltip
                                    position="top-left"
                                    intent={Intent.PRIMARY}
                                    content={__("Double")}
                                >
                                    <Button variant={ButtonVariant.MINIMAL} >
                                        <Icon size={20} icon="duplicate" className="m-0" />
                                    </Button>
                                </Tooltip>
                                <Tooltip
                                    position="top-left"
                                    intent={Intent.PRIMARY}
                                    content={__("Delete")}
                                >
                                    <Button variant={ButtonVariant.MINIMAL} intent="danger" onClick={onRmv} >
                                        <Icon size={20} icon="trash" className="m-0"/>
                                    </Button>   
                                </Tooltip>          
                            </div> 
                    }
                    <div className="d-flex align-items-center ">                        
                        {
                            !!props.presetLib 
                                ?
                                <>
                                    <span className="px-0 smaller text-uppercase letter-spacing-1 hover-border">{ __( "Edit" ) }</span>
                                    <PresetLib title={ props.presetLib } onMouseOver={ onLibOpen } />
                                </>
                                :
                                <Icon size={20} icon={ isOpen ? "chevron-down" : "chevron-right" } className="hover px-3" />
                        }
                    </div> 
                </div>
            </Button> 
            <ScalableDialog
                isOpen={isOpen}
                dialogSize={DIALOG_SIZE.NORMAL}
                onClose={() => setIsOpen(false)}
            >
                isOpen && <CompositeContent 
                    value={value.get()}
                    origin={props.origin}
                    contentType={contentType.get()}
                    isCollapsesOpen={isCollapsesOpen}
                    onCollapsesOpen={onCollapsesOpen}
                    schemaType={schemaType}
                    schemaData={schemaData}
                    onChange={onChange} 
                    presetLib={props.presetLib}
                />
            </ScalableDialog> 
        </CompositeContainer>
}

export interface IComponentContent {
    contentType: CONTENT_TYPE
    schemaType: any
    value: any
    origin: any
    schemaData: any
    isCollapsesOpen: boolean
    presetLib?: string 
    onCollapsesOpen: (i: number) => void
    onChange: (value: any, field: string, data: any) => void
}

export const CompositeContent = (props: any): JSX.Element => {
    return <div className="px-3 max-height overflow-y-auto">
        <div className="p-0 row">
            {
                props.contentType === CONTENT_TYPE.VALUE
                    ?
                    <CompositeForm 
                        schemaType={ props.schemaType } 
                        origin={ props.origin }
                        value={ props.value }
                        onChange={ props.onChange }
                        schemaData={ props.schemaData} 
                        onCollapsesOpen={ props.onCollapsesOpen }
                        isCollapsesOpen={ props.isCollapsesOpen }
                    />
                    :
                    props.contentType === CONTENT_TYPE.LIB
                        ?
                        <PresetLibraryList libName={ props.presetLib } />
                        :
                        <></>
            }
        </div>
    </div>
}

export const CompositeContainer = ({isNotCard, children }:any): JSX.Element => {
    return isNotCard
        ?
        <div className="container">
            <div className='pe-comp-widget row m-1'>              
                <div className=" col-12"> 
                    {children}
                </div>
            </div>
        </div>
        :
        <div className="container ml-0">
            <div className='pe-comp-widget row m-0 '>            
                <div className="border1 border-contrast-secondary-opacity rounded-1 col-12 p-0 d-flex align-items-center flex-grow-100"> 
                    {children}
                </div>
            </div>
        </div>
}

export default LandingCompositeDefault

export function isShowByParent( parentValues: any[], schemaType: any, parentField: string, origin: any ):boolean {
    const boo2 = parentValues?.filter((_key:any) => {
        let boo = ( ( origin ? origin[parentField] : {} ) || schemaType[parentField]?.default ) === _key 
        return boo
    }).length 
    return !!boo2
}
 
/** example */
export function isShowByGrands( schemaType: any, field: string, origin: any, isTab:boolean = false ): boolean {
    let bool: boolean = true

    const required = isTab
        ?
        schemaType.find((tab: any) => tab._id === field)?.required
        :
        schemaType[field]?.required
    if(!Array.isArray(required)) return bool
    
    
    const requireField = required[0]
    const parentValues: any[] = required.slice(1)
    const is1 = (origin || {})[ requireField ] // текущее зависящее значение
    const is2 = schemaType[requireField]?.default
    const is = !!parentValues.filter(requireV => {
        return typeof ( is1 || is2 ) === "boolean"
            ? 
            !!( is1 ) === !!requireV
            :
            ( is1 || is2 )   === requireV 
    }).length

    if(!is){
        return false
    }
    return isShowByGrands( schemaType, requireField, origin)
} 